export default {
  16128:{
    "name":"BSPREF",
    "value":""
  },
  16129:{
    "name":"BSESSN",
    "value":""
  },
  16130:{
    "name":"BSINTT",
    "value":""
  },
  16131:{
    "name":"BSCOMC",
    "value":""
  },
  16133:{
    "name":"BSIOLC",
    "value":""
  },
  16134:{
    "name":"BSSAVG",
    "value":""
  },
  16135:{
    "name":"BSCOMM",
    "value":""
  },
  16136:{
    "name":"BSPRMM",
    "value":""
  },
  16137:{
    "name":"BSLLOC",
    "value":""
  },
  16138:{
    "name":"BSLTER",
    "value":""
  },
  16139:{
    "name":"BSLREL",
    "value":""
  },
  16140:{
    "name":"BSLELC",
    "value":""
  },
  16141:{
    "name":"BSBRCC",
    "value":""
  },
  16142:{
    "name":"BSBPPC",
    "value":""
  },
  16143:{
    "name":"BACCHC",
    "value":""
  },
  16144:{
    "name":"BAPBCC",
    "value":""
  },
  16145:{
    "name":"BABOLB",
    "value":""
  },
  16146:{
    "name":"BABMLB",
    "value":""
  },
  16147:{
    "name":"BAMERS",
    "value":"N"
  },
  16100:{
    "name":"CNACCK",
    "value":""
  },
  16101:{
    "name":"CNCONK",
    "value":""
  },
  16102:{
    "name":"CNPRIOK",
    "value":""
  },
  16103:{
    "name":"CNPVBK",
    "value":""
  },
  16148:{
    "name":"CNPVCK",
    "value":""
  },
  16104:{
    "name":"CNFRCD",
    "value":""
  },
  16105:{
    "name":"CNRRCD",
    "value":""
  },
  16108:{
    "name":"CNMMAT",
    "value":""
  },
  16109:{
    "name":"CNPMMA",
    "value":""
  },
  16110:{
    "name":"CNSILS",
    "value":""
  },
  16111:{
    "name":"CNCCSV",
    "value":""
  },
  16112:{
    "name":"CNHDYL",
    "value":""
  },
  16113:{
    "name":"CNPRLC",
    "value":""
  },
  16114:{
    "name":"CNUNSL",
    "value":""
  },
  16115:{
    "name":"CNPSLO",
    "value":""
  },
  16152:{
    "name":"CNSVSC",
    "value":""
  },
  16151:{
    "name":"CNAUSC",
    "value":""
  },
  16116:{
    "name":"CNHELN",
    "value":""
  },
  16117:{
    "name":"CNHELO",
    "value":""
  },
  16118:{
    "name":"CNMRRF",
    "value":""
  },
  16119:{
    "name":"CNVPCC",
    "value":""
  },
  16120:{
    "name":"CNPVPC",
    "value":""
  },
  16149:{
    "name":"CNPVHE",
    "value":""
  },
  16150:{
    "name":"CNPVLC",
    "value":""
  },
  16121:{
    "name":"CAHWCC",
    "value":""
  },
  16122:{
    "name":"CAPCCC",
    "value":""
  },
  16123:{
    "name":"CAPVCC",
    "value":""
  },
  16124:{
    "name":"CACOLB",
    "value":""
  },
  16125:{
    "name":"CACMLB",
    "value":""
  },
  16126:{
    "name":"CAOVDS",
    "value":""
  },
  16127:{
    "name":"CAOVPS",
    "value":""
  },
  16154:{
    "name":"CNISRF",
    "value":""
  },
  16155:{
    "name":"CNAODP",
    "value":""
  },
  16156:{
    "name":"CNPEXR",
    "value":""
  },
  16157:{
    "name":"CNASRE",
    "value":""
  },
  16158:{
    "name":"BSBSCD",
    "value":""
  },
  16159:{
    "name":"CNFSSV",
    "value":""
  }
}
